export function TrackingIcon({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <g id="Group_24492" data-name="Group 24492" transform="translate(-865 -172)">
        <g
          id="Rectangle_10299"
          data-name="Rectangle 10299"
          transform="translate(865 172)"
          fill="#fff"
          stroke="#eef3f5"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <g id="Group_16820" data-name="Group 16820" transform="translate(0.75 1)">
          <path
            id="Path_41464"
            data-name="Path 41464"
            d="M619.719,5560.4a2.7,2.7,0,1,0-2.719-2.7A2.708,2.708,0,0,0,619.719,5560.4Z"
            transform="translate(256.531 -5376.5)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
          />
          <path
            id="Path_41465"
            data-name="Path 41465"
            d="M619.25,5568c3.625-3.6,7.25-6.822,7.25-10.8a7.25,7.25,0,0,0-14.5,0C612,5561.178,615.625,5564.4,619.25,5568Z"
            transform="translate(257 -5376)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
          />
        </g>
      </g>
    </svg>
  );
}
